import * as React from "react"
import type { SVGProps } from "react"
const SvgPdfFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8 17.57h1q.42 0 .71-.29a1 1 0 0 0 .29-.71v-1a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H7.5a.5.5 0 0 0-.35.15.5.5 0 0 0-.15.35v4q0 .2.15.35a.5.5 0 0 0 .7 0q.15-.15.15-.35zm0-1v-1h1v1zm5 3q.42 0 .71-.29a1 1 0 0 0 .29-.71v-3a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-1.5a.5.5 0 0 0-.35.15.5.5 0 0 0-.15.35v4q0 .2.15.35t.35.15zm-1-1v-3h1v3z"
    />
    <path d="M16 17.57h.5a.5.5 0 0 0 .35-.15.5.5 0 0 0 0-.7.5.5 0 0 0-.35-.15H16v-1h.5a.5.5 0 0 0 .35-.15.5.5 0 0 0 0-.7.5.5 0 0 0-.35-.15h-1a.5.5 0 0 0-.35.15.5.5 0 0 0-.15.35v4q0 .2.15.35a.5.5 0 0 0 .7 0q.15-.15.15-.35z" />
    <path
      fillRule="evenodd"
      d="M4.59 21.98q.59.6 1.41.6h12q.83 0 1.41-.6.6-.59.59-1.4V9.4a2 2 0 0 0-.57-1.4l-4.85-4.85a2 2 0 0 0-1.4-.58H6q-.82 0-1.41.59A2 2 0 0 0 4 4.57v16q0 .82.59 1.41M13 4.57v4q0 .42.29.71.29.3.71.29h4v11H6v-16z"
    />
  </svg>
)
export default SvgPdfFile
